export const TypesVistoriaOEA = {
    INICIAR_SESSAO: "vistoriaOEA/INICIAR_SESSAO",
    ATUALIZAR_CAMPO: "vistoriaOEA/ATUALIZAR_CAMPO",
    ATUALIZAR_CAMPOS: "vistoriaOEA/ATUALIZAR_CAMPOS",
    RESETAR: "vistoriaOEA/RESETAR"
};

export const INITIAL = {
    hashProcess: "",
    terminal: "",
    container: "",
    placaCavalo: "",
    placaSemirreboque: "",
    tipoInspecao: "",
    tipoContainer: "",
    regime: "",
    local: "",
    observacao: "",
    vistoriaOeaPendenteId: null
};

export default function vistoriaOEAReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesVistoriaOEA.INICIAR_SESSAO:
            return { ...INITIAL, hashProcess: action.payload.hashProcess };

        case TypesVistoriaOEA.ATUALIZAR_CAMPO:
            return {
                ...state,
                [action.payload.campo]: action.payload.valor
            };

        case TypesVistoriaOEA.ATUALIZAR_CAMPOS:
            return {
                ...state,
                ...action.payload.campos
            };

        case TypesVistoriaOEA.RESETAR:
            return INITIAL;

        default:
            return state;
    }
}

function iniciarSessao(hashProcess) {
    return {
        type: TypesVistoriaOEA.INICIAR_SESSAO,
        payload: { hashProcess }
    };
}

function atualizarCampo(campo, valor) {
    return {
        type: TypesVistoriaOEA.ATUALIZAR_CAMPO,
        payload: { campo, valor }
    };
}

function atualizarCampos(campos) {
    return {
        type: TypesVistoriaOEA.ATUALIZAR_CAMPOS,
        payload: { campos }
    };
}

function atualizarTerminal(terminal) {
    return atualizarCampo("terminal", terminal);
}

function atualizarContainer(container) {
    return atualizarCampo("container", container);
}

function atualizarPlacaCavalo(placaCavalo) {
    return atualizarCampo("placaCavalo", placaCavalo);
}

function atualizarPlacaSemirreboque(placaSemirreboque) {
    return atualizarCampo("placaSemirreboque", placaSemirreboque);
}

function atualizarTipoInspecao(tipoInspecao) {
    return atualizarCampo("tipoInspecao", tipoInspecao);
}

function atualizarTipoContainer(tipoContainer) {
    return atualizarCampo("tipoContainer", tipoContainer);
}

function atualizarRegime(regime) {
    return atualizarCampo("regime", regime);
}

function atualizarLocal(local) {
    return atualizarCampo("local", local);
}

function atualizarObservacao(observacao) {
    return atualizarCampo("observacao", observacao);
}

function resetar() {
    return { type: TypesVistoriaOEA.RESETAR };
}

export const VistoriaOEAActions = {
    iniciarSessao,
    atualizarCampo,
    atualizarCampos,
    atualizarTerminal,
    atualizarContainer,
    atualizarPlacaCavalo,
    atualizarPlacaSemirreboque,
    atualizarTipoInspecao,
    atualizarTipoContainer,
    atualizarRegime,
    atualizarLocal,
    atualizarObservacao,
    resetar
};
